<span class="badge {{badgeBackgroundClass}} fs-2 fw-bold text-uppercase border border-white shadow-lg px-3">{{statusText}}</span>
